import { Component, input, output } from "@angular/core";

@Component({
  selector: "tile-button",
  templateUrl: "./tile-button.component.html",
})
export class TileButtonComponent {
  title = input<string>("");
  description = input<string>("");
  isEnabled = input<boolean>(true);
  testId = input<string>();
  onClick = output<void>();

  handleClick() {
    if (!this.isEnabled()) {
      return;
    }
    this.onClick.emit();
  }
}
